module.exports = __webpack_public_path__ + "img/computer.0fbc487b.png";